type Props = { invalidity: boolean };
export const InvalidityStateBadge = ({ invalidity }: Props) => {
  return (
    <>
      {invalidity ? (
        <span className="badge badge-warning">無効</span>
      ) : (
        <span className="badge badge-success">有効</span>
      )}
    </>
  );
};
